import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const DEVICE_MAP_URL = "https://assets.apprevbooster.com/devices.json";

/**
 * Hook to fetch the device map from CDN and cache it infinitely.
 * Returns a mapping of device code to human-readable device name.
 */
export const useDeviceMap = () => {
    return useQuery<Record<string, string>, Error>({
        queryKey: ["device-map"],
        queryFn: async () => {
            try {
                const response = await axios.get(DEVICE_MAP_URL);
                return response.data;
            } catch (error) {
                console.error("Failed to fetch device map:", error);
                throw error;
            }
        },
        staleTime: Infinity,
        gcTime: Infinity,
    });
};
